import { memo, useEffect, useState } from "react";
import { ProgressBar, Stack, Row, Col, Container } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalHeader, BzSlider } from "../../components";
import { useSelector, useDispatch } from "react-redux";
import { getHealthTotalScoreData } from "../../redux/actions/marketOverview";
import { getAssetExchangeNameFromMktSegId } from "../../utils/global_functions";
import { HEALTHSCORE_DESC, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { handleModal } from "../../redux/actions/modals";
const colorCode = {
    text: {
        "Poor": "healthscore-poor-textcolor",
        "Fair": "healthscore-fair-textcolor",
        "Good": "healthscore-good-textcolor",
        "Excellent": "healthscore-excellent-textcolor",
    },
    bg: {
        "Poor": 'healthscore-poor-background',
        "Fair": 'healthscore-fair-background',
        "Good": 'healthscore-good-background',
        "Excellent": 'healthscore-excellent-background',
    }
};
const HealthScore = ({ isVertical = true }) => {
    const dispatch = useDispatch();
    const healthTotalScore = useSelector(state => state.marketOverview.healthScore);
    const [activeTabKey, setActiveTabKey] = useState('strength');
    const modals = useSelector(state => state.modals.modals);
    const arrHealthParamScore = useSelector(state => state.marketOverview.arrHealthParamScore);
    const arrHealthParamValues = useSelector(state => state.marketOverview.arrHealthParamValues);
    const scripOverviewData = useSelector((state) => state.marketOverview.scripOverviewData);
    const [slideText, setSlideText] = useState('');
    const value = (healthTotalScore?.length) ? healthTotalScore[0]?.TotalScore : '0';
    const health = (healthTotalScore?.length) ? healthTotalScore[0]?.HealthStatus : 'Poor';
    const arrMainMenus = [
        { name: 'Strength', id: 'strength' },
        { name: 'Valuation', id: 'valuation' },
        { name: 'Growth', id: 'growth' },
        { name: 'Returns', id: 'returns' },
        { name: 'Holdings', id: 'holdings' },

    ];
    const isPositiveOrNegative = (val) => {
        if (val === '0') {
            return '-ve';
        } else {
            return '+ve';
        }
    };
    const arrMainTable = {
        strength:
            [
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.cr_score), name: 'Current Ratio', numberValue: parseFloat(arrHealthParamScore?.[0]?.cr)?.toFixed(2), Desc: HEALTHSCORE_DESC.CURRENT_RATIO },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.der_score), name: 'Debt-Equity Ratio', numberValue: parseFloat(arrHealthParamScore?.[0]?.der)?.toFixed(2), Desc: HEALTHSCORE_DESC.DEBT_EQUITY_RATIO },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.assetto_score), name: 'Asset Turnover Ratio', numberValue: parseFloat(arrHealthParamScore?.[0]?.assetto)?.toFixed(2), Desc: HEALTHSCORE_DESC.ASSET_TURNOVER_RATIO },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.divyield_score), name: 'Dividend Yield', numberValue: parseFloat(arrHealthParamScore?.[0]?.divyield)?.toFixed(2), Desc: HEALTHSCORE_DESC.DIVIDEND_YIELD }
            ],
        valuation:
            [
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.pe_score), name: 'PE', numberValue: parseFloat(arrHealthParamScore?.[0]?.pe)?.toFixed(2), Desc: HEALTHSCORE_DESC.PE },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.pb_score), name: 'PBV', numberValue: parseFloat(arrHealthParamScore?.[0]?.pb)?.toFixed(2), Desc: HEALTHSCORE_DESC.PBV },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.eps_ttm_score), name: 'EPS', numberValue: parseFloat(arrHealthParamScore?.[0]?.eps_ttm)?.toFixed(2), Desc: HEALTHSCORE_DESC.EPS },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.earningyield_score), name: 'Earning Yield', numberValue: parseFloat(arrHealthParamScore?.[0]?.earningyield).toFixed(2), Desc: HEALTHSCORE_DESC.EARNING_YIELD }
            ],
        growth:
            [
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.salesttm_growth_score), name: 'Sales Growth', numberValue: parseFloat(arrHealthParamScore?.[0]?.salesttm_growth).toFixed(2), Desc: HEALTHSCORE_DESC.SALES_GROWTH },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.profitttm_growth_score), name: 'Profit Growth', numberValue: parseFloat(arrHealthParamScore?.[0]?.profitttm_growth).toFixed(2), Desc: HEALTHSCORE_DESC.PROFIT_GROWTH },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.ebidtattm_growth_score), name: 'EBIDTA Growth', numberValue: parseFloat(arrHealthParamScore?.[0]?.ebidtattm_growth)?.toFixed(2), Desc: HEALTHSCORE_DESC.EBITDA_GROWTH },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.ebitttm_growth_score), name: 'EBIT Growth', numberValue: parseFloat(arrHealthParamScore?.[0]?.ebitttm_growth)?.toFixed(2), Desc: HEALTHSCORE_DESC.EBIT_GROWTH }
            ],
        returns:
            [
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.ronw_score), name: 'RONW', numberValue: parseFloat(arrHealthParamScore?.[0]?.ronw)?.toFixed(2), Desc: HEALTHSCORE_DESC.RONW },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.roce_score), name: 'ROCE', numberValue: parseFloat(arrHealthParamScore?.[0]?.roce)?.toFixed(2), Desc: HEALTHSCORE_DESC.ROCE },
            ],
        holdings:
            [
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.foreigninstitutions_score), name: 'Foreign Institutions', numberValue: parseFloat(arrHealthParamScore?.[0]?.foreigninstitutions)?.toFixed(2), Desc: HEALTHSCORE_DESC.FOREGIN_INSTITUTIONS },
                { value: isPositiveOrNegative(arrHealthParamValues?.[0]?.promoterpledge_score), name: 'Promoter Pledge', numberValue: parseFloat(arrHealthParamScore?.[0]?.promoterpledge)?.toFixed(2), Desc: HEALTHSCORE_DESC.PROMOTER_PLEDGE },
            ]
    }
    useEffect(()=>{
        const exchangeType = getAssetExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]);
        if(healthTotalScore?.length===0){
            const objPayload = {
                // BT-114569 : Functional Implementation : Vaibhav Singh : 01-07-2023 : fixed for apicall when inline search is triggered
                nToken: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
                exchangeType: exchangeType,
                mktSegmentId: getAssetExchangeNameFromMktSegId(scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]),
                jtenantToken: 1,
            };
            dispatch(getHealthTotalScoreData(objPayload));
        }
    }, [scripOverviewData, healthTotalScore, dispatch]);
    useEffect(() => {
        if (value) {
            setSlideText(value);
        }
    }, [value]);
    const handleModalHealthScore = () => {
        dispatch(handleModal([{ 'HEALTH_MODAL_OPEN': true }]));
    };
    const onCloseHealth = () => {
        dispatch(handleModal([{ 'HEALTH_MODAL_OPEN': false }]));
    };
    const handleTab = (each) => {
        setActiveTabKey(each);
    };
    const mostFrquentValue = (data, key) => Object.entries(data.reduce((acc, obj) => ({ ...acc, [obj[key]]: (acc[obj[key]] || 0) + 1 }), {})).reduce((a, b) => b[1] > a[1] ? b : a);
    return (
        <>
            <BzModal data-testid="market-overview-health=score-analysis-modal" centered size='lg' show={modals['HEALTH_MODAL_OPEN']} onHide={onCloseHealth} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <div className='font-medium font-size4 color-text'>Health Score Analysis</div>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={onCloseHealth}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-2'>
                            <Col md={5} className='d-flex mrgauto'>
                                <div className={`healthscore-highlighter ${colorCode?.bg?.[health]}`}>
                                    <div className={`d-flex justify-content-center`}>
                                        <div className='d-flex align-items-center pe-2'>
                                            <div className='font-regular font-size4 color-text'>Status:</div>
                                            <div className={`font-medium font-size5 ms-1 ${colorCode?.text?.[health]}`}>{health}</div>
                                        </div>
                                        <div className='d-flex align-items-center ps-2'>
                                            <div className='font-regular font-size4 color-text'>Score:</div>
                                            <div className={`font-medium font-size5 ms-1 ${colorCode?.text?.[health]}`}>{value} / <span className='font-regular font-size4 color-text'>100</span></div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-4'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <div className='font-regular font-size1 color-subtext'>Poor (0-25), &nbsp;Fair (26-50), &nbsp;Good (51-75), &nbsp;Excellent (76-100)</div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-4'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <div className='submenu-wrapper horizontal-scroll-wrap pb-1'>
                                    <Stack direction="horizontal" className='d-flex justify-content-center'>
                                        {
                                            arrMainMenus?.map((objMenu) => (
                                                <div className={`submenuItem ${activeTabKey === objMenu?.id ? "active" : ""}`} onClick={() => { handleTab(objMenu?.id); }} tabKey={objMenu?.id}>{objMenu?.name}</div>
                                            ))
                                        }
                                    </Stack>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-4'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <div className='font-regular font-size2 color-text'>Analysis:</div>
                                <div className={`font-medium font-size3 color-positive ms-1 ${mostFrquentValue(arrMainTable?.[activeTabKey], 'value')?.[0] === '-ve' ? 'color-negative' : 'color-positive'}`}>{mostFrquentValue(arrMainTable?.[activeTabKey], 'value')?.[0] === "-ve" ? 'Negative' : 'Positive'}</div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-2'>
                            <Col className='d-flex justify-content-center align-items-center'>
                                <table className='table table-sm bdr'>
                                    <tbody>
                                        {
                                            arrMainTable?.[activeTabKey]?.map((obj) => (
                                                <tr>
                                                    <td className={`font-regular font-size2 table-td-color-text bdr align-middle text-center col-md-1 ${obj?.value === '+ve' ? 'color-positive healthscore-good-background' : 'color-negative healthscore-poor-background'}`}>{obj?.value}</td>
                                                    <td className='font-medium font-size2 table-td-color-text bdr align-middle text-center col-md-2'>{obj?.name}</td>
                                                    <td className='font-medium font-size2 table-td-color-text bdr align-middle text-center col-md-1'>{obj?.numberValue}</td>
                                                    <td className='font-regular font-size1 table-td-color-text bdr align-middle col-md-6'>{obj?.Desc}</td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
            </BzModal>
            {isVertical ?
                <Container fluid className='p-0'>
                    <div className='scripoverview-fieldset'>
                        <div className='scripoverview-fieldset-sm'>
                            <div className='scripoverview-legend'>HEALTH SCORE</div>
                            <Row className='g-0 py-5 so-health-score-wrapper mt-5'>
                                <Col>
                                    <div className={`so-health-score-pointer ${colorCode?.text?.[health]}`} style={{ left: `${(slideText < 5) ? '10%' : slideText}%` }}>
                                        {health}({value})
                                    </div>

                                    <BzSlider data-testid="market-overview-health-score-slider" className='so-health-score-slider' defaultValue={parseInt(value)} onChange={(e) => {
                                        e.target.value = value;
                                    }} />

                                    <Stack direction='vertical' className='d-flex justify-content-between so-health-score-progressbar-wrapper pt-5'>
                                        <Container>
                                            <ProgressBar now={100} className='w-100'>
                                                <ProgressBar className='background-poor' now={25} key={1} />
                                                <ProgressBar className='background-fair' now={25} key={2} />
                                                <ProgressBar className='background-good h-100' now={25} key={3} />
                                                <ProgressBar className='background-excellent' now={25} key={4} />
                                            </ProgressBar>
                                            <Row className='g-0 so-health-score-value-wrapper'>
                                                <Col className='so-health-score-value value-0'>0</Col>
                                            </Row>
                                            <Row className='g-0 so-health-score-value-wrapper'>
                                                <Col className='so-health-score-grade grade-poor'>Poor</Col>
                                                <Col className='so-health-score-value value-25'>25</Col>
                                            </Row>
                                            <Row className='g-0 so-health-score-value-wrapper'>
                                                <Col className='so-health-score-grade grade-fair'>Fair</Col>
                                                <Col className='so-health-score-value value-50 col-auto ms-2'>50</Col>
                                            </Row>
                                            <Row className='g-0 so-health-score-value-wrapper'>
                                                <Col className='so-health-score-grade grade-good'>Good</Col>
                                                <Col className='so-health-score-value value-75 col-auto ms-2'>75</Col>
                                            </Row>
                                            <Row className='g-0 so-health-score-value-wrapper'>
                                                <Col className='so-health-score-grade grade-excellent'>Excellent</Col>
                                                <Col className='so-health-score-value value-100 col-auto ms-2'>100</Col>
                                            </Row>
                                        </Container>
                                    </Stack>
                                </Col>
                            </Row>
                            <Row className='g-0 mt-3'>
                                <Col className='d-flex justify-content-center'>
                                    <BzButton data-test-id="market-overview-view-complete-analysis-button" className='btn btn-sm btn-outline' onClick={handleModalHealthScore}>View Complete Analysis</BzButton>
                                </Col>
                            </Row>

                        </div>
                    </div>
                </Container>
                :
                <>
                    <Container fluid className='p-0'>
                        <Row className='g-0 my-2'>
                            <Col className='font-medium font-size2 color-text'>Health Score</Col>
                        </Row>
                        <Row className='g-0 aling-items-center so-health-score-side bdr-btm'>
                            <Col>
                                <div className='g-0 py-5 so-health-score-wrapper'>
                                    <div className={`so-health-score-pointer ${colorCode?.text?.[health]}`} style={{ left: `${(slideText < 5) ? '10%' : slideText}%` }}>
                                        {health}({value})
                                    </div>
                                    <BzSlider data-testid="market-overview-health-score-slider" min="1" max='100' className='so-health-score-slider' defaultValue={parseInt(value)} value={parseInt(value)} onChange={(e) => {
                                        e.target.value = parseInt(value);
                                    }} />
                                    <Stack direction='vertical' className='d-flex w-100 justify-content-between pt-5 so-health-score-progressbar-wrapper '>
                                        <ProgressBar now={100} className='w-100'>
                                            <ProgressBar className='background-poor' now={25} key={1} />
                                            <ProgressBar className='background-fair' now={25} key={2} />
                                            <ProgressBar className='background-good h-100' now={25} key={3} />
                                            <ProgressBar className='background-excellent' now={25} key={4} />
                                        </ProgressBar>
                                        <Row className='g-0 so-health-score-value-wrapper'>
                                            <Col md='1' className='so-health-score-value-sidetray value-0 text-center'>0</Col>
                                        </Row>
                                        <Row className='g-0 so-health-score-value-wrapper'>
                                            <Col md='1' className='so-health-score-grade-sidetray grade-poor text-center'>Poor</Col>
                                            <Col md='1' className='so-health-score-value-sidetray value-25 text-center'>25</Col>
                                        </Row>
                                        <Row className='g-0 so-health-score-value-wrapper'>
                                            <Col md='1' className='so-health-score-grade-sidetray grade-fair text-center'>Fair</Col>
                                            <Col md='1' className='so-health-score-value-sidetray value-50 text-center'>50</Col>
                                        </Row>
                                        <Row className='g-0 so-health-score-value-wrapper'>
                                            <Col md='1' className='so-health-score-grade-sidetray grade-good text-center'>Good</Col>
                                            <Col md='1' className='so-health-score-value-sidetray value-75 text-center'>75</Col>
                                        </Row>
                                        <Row className='g-0 so-health-score-value-wrapper'>
                                            <Col md='1' className='so-health-score-grade-sidetray grade-excellent text-center'>Excellent</Col>
                                            <Col md='auto' className='so-health-score-value-sidetray value-100 text-center'>100</Col>
                                        </Row>
                                    </Stack>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </>
            }
        </>
    );
};
export default memo(HealthScore);